// LoadingBar.js
import React from 'react';

const LoadingBar = () => {
    return (
        <div className="loading-bar-container">
            <div className="loading-bar"></div>
        </div>
    );
};

export default LoadingBar;
